const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';
const API_TIMEOUT = import.meta.env.VITE_API_TIMEOUT || 30000;

export const config = {
  apiUrl: API_URL,
  apiTimeout: API_TIMEOUT,
  // Feature flags
  enableAiCoach: import.meta.env.VITE_ENABLE_AI_COACH === 'true',
  enableProgressiveDashboard: import.meta.env.VITE_ENABLE_PROGRESSIVE_DASHBOARD === 'true',
  enableHapticFeedback: import.meta.env.VITE_ENABLE_HAPTIC_FEEDBACK === 'true',
  // Environment
  environment: import.meta.env.VITE_ENV || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};